import { render, staticRenderFns } from "./InventoryLookup.vue?vue&type=template&id=5bc6955f"
import script from "./InventoryLookup.vue?vue&type=script&lang=js"
export * from "./InventoryLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports